// When an older section type draws with its v2 component (src/sections):
// only once the studio has saved blocks (Words) or a layout. Pages nobody
// has edited keep today's components, so they look exactly as they do now.
// Pure, for tests/s2Pick.test.js.

export function s2UsesV2(section) {
    if (!section || typeof section !== "object") return false;
    if (section.type === "content") {
        return (Array.isArray(section.blocks) && section.blocks.length > 0) || ["narrow", "normal", "wide"].includes(section.layout);
    }
    const layouts = {
        split: ["left", "right", "overlap", "strip", "arch"],
        features: ["cards", "list", "icons", "tabs", "photo-cards"],
        "image-grid": ["grid", "masonry", "carousel", "filmstrip"],
    }[section.type];
    return !!layouts && layouts.includes(section.layout);
}
